import FilterDropDown from 'components/FilterDropDown';
import SearchBar from 'components/Searchbar';
import classNames from './internal-job-list.module.css';
import flagIcon from 'images/svg/Group 36510.svg';
import {useHistory} from 'react-router-dom';
import {useJobboardList} from './useJobboardList';
import {useState} from 'react';
import MapIcon from 'images/svg/Icon feather-map-pin.svg';
import folderIcon from 'images/svg/Icon feather-folder.svg';
import PathIcon from 'images/svg/Path 5192.svg';
import {Loading} from 'erp-react-components';
import Pagination from 'components/Pagination';
import {useTableScroll} from 'components/customHooks/useTableBottomScroll';
import JobBoardMenu from 'components/JobboradMenu';
import {Trans, useTranslation} from 'react-i18next';
import JobBoardMenuMobileView from 'components/JobboradMenu/job-board-menu-mobile-view';

const InternalJobBoardList = () => {
  const {t} = useTranslation();
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [isInternal, setisInternal] = useState(true);
  const [refreshFlag, setrefreshFlag] = useState(null);
  const history = useHistory();

  function handleRedirectView(row, type) {
    if (type === 'view')
      history.push({
        pathname: `/internal/viewJob/${row?.position_number}`,
        state: {ViewJob: row, postId: row?.position_number},
      });
    else
      history.push({
        pathname: `/internal/applyjob/${row?.position_number}`,
        state: {ViewJob: row, postId: row?.position_number},
      });
  }

  const {
    isLoading,
    data,
    jobboardList,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useJobboardList({
    filters,
    isInternal,
    searchTerm,
    setFilters,
  });

  const totalJobListCount =
    (data?.pages || [])[0]?.data?.pagination?.total || 0;

  useTableScroll(() => {
    fetchNextPage();
  }, '.fetch-jobboard-list');

  return (
    <>
      <SearchBar
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        refreshFlag={refreshFlag}
      />
      <div>
        <FilterDropDown
          dropdown={true}
          setFilters={setFilters}
          filter={filters}
          module={'job-list'}
        />
      </div>
      <div className={classNames['internal-job-container']}>
        <div className={classNames['internal-job-sub-container']}>
          <div className={classNames['internal-job-info-container']}>
            <div className={classNames['internal-job-info']}>
              <JobBoardMenu
                active={'search-job'}
                setSearchTerm={setSearchTerm}
                setFilters={setFilters}
                setrefreshFlag={setrefreshFlag}
              />
            </div>
          </div>{' '}
          {!isLoading ? (
            <>
              <div className={classNames['job-board-list-container']}>
                <div className={classNames['profile-section']}>
                  {jobboardList?.length ? (
                    <div
                      className={classNames['internal-filter-with-pagination']}
                    >
                      <div>
                        <input
                          className={classNames['switch']}
                          type="checkbox"
                          defaultChecked={isInternal}
                          onClick={(e) =>
                            setisInternal(
                              (e.target as HTMLInputElement).checked,
                            )
                          }
                        ></input>
                        <span className={classNames['switch-text-font']}>
                          {t('Search_Job_Internal Jobs')}
                        </span>
                      </div>
                      <div className={classNames['pagination-m']}>
                        <Pagination
                          loadNext={isFetchingNextPage}
                          displayCount={jobboardList?.length}
                          totalCount={totalJobListCount}
                        />
                        {isFetchingNextPage ? <Loading /> : <></>}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {!isLoading && !jobboardList?.length ? (
                  <div className={classNames['records-not-found']}>
                    {t('Records Not Found')}
                  </div>
                ) : (
                  <div
                    className={`awl-custom-scroll fetch-jobboard-list ${classNames['internal-job-list']}`}
                  >
                    {(jobboardList || []).map((j) => {
                      let branch_ = [];
                      (j?.job_posted_to || []).forEach((j) => {
                        branch_ = [...branch_, ...j?.branches];
                      });
                      branch_ = (branch_ || []).filter(
                        (arr, index, self) =>
                          index === self.findIndex((t) => t.id === arr.id),
                      );
                      return (
                        <div
                          className={`mb-2 ${classNames['how-to-apply-title-text']}`}
                          key={j?.position_number}
                        >
                          {(j?.job_posted_to || []).some((p) => {
                            return p?.job_post_type === 'internal';
                          }) ? (
                            <div className={classNames['view-job-flag-colse']}>
                              <div className={classNames['flag-icon']}>
                                <img src={flagIcon} />
                              </div>
                              <div
                                className={
                                  classNames['view-job-others-m'] +
                                  ' ' +
                                  classNames['view-job-close-m']
                                }
                              >
                                <Trans
                                  i18nKey={'Search_Job_ClosesStatus'}
                                  t={t}
                                  defaults={
                                    'Closes in {{position_closing_num}} {{position_closing_unit}}'
                                  }
                                  components={{
                                    1: <strong />,
                                  }}
                                  values={{
                                    position_closing_num:
                                      j?.hr_closing_days_left,
                                    position_closing_unit:
                                      j?.hr_closing_days_left
                                        ? t('JOB_BOARD_LIST_days')
                                        : '',
                                  }}
                                />{' '}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div className={classNames['flag-icon']}>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                              </div>
                            </div>
                          )}

                          <div className="ml-4">
                            <div
                              className={` ${classNames['view-job-details']}`}
                            >
                              <div>
                                <strong
                                  className={`mr-2 ${classNames['heading-font']}`}
                                >
                                  <button
                                    className={classNames['position-number']}
                                    onClick={() =>
                                      history.push(
                                        `/viewJob/${j?.position_number}`,
                                      )
                                    }
                                  >
                                    <strong>
                                      {j?.position_number || ''} -{' '}
                                      {` ${j?.role}`}
                                    </strong>
                                  </button>
                                </strong>
                                <div
                                  className={classNames['view-job-others-m']}
                                ></div>
                                <span>
                                  <img
                                    className={`mr-1 ${classNames['view-job-map-icon']}`}
                                    src={MapIcon}
                                  />
                                </span>
                                <span className={classNames['default-text']}>
                                  {(branch_ || [])
                                    .map((b) => {
                                      return b?.name;
                                    })
                                    ?.join(', ')}
                                </span>
                              </div>
                            </div>
                            <div className={classNames['employment-type']}>
                              <div>
                                {' '}
                                <img
                                  className={classNames['view-job-dept']}
                                  src={folderIcon}
                                ></img>
                                <span className="mr-2">
                                  {j?.department?.name || ''} |{' '}
                                  {j?.contract_type || ''}
                                </span>
                                {j?.is_remote_job == 2 ? (
                                  <span className={classNames['hybird-status']}>
                                    {t('JOB_BOARD_Hybrid')}
                                  </span>
                                ) : j?.is_remote_job == 1 ? (
                                  <span className={classNames['remort-status']}>
                                    {t('JOB_BOARD_Remote')}
                                  </span>
                                ) : (
                                  <span className={classNames['onsite-status']}>
                                    {t('JOB_BOARD_Studio')}
                                  </span>
                                )}
                              </div>
                              <div
                                className={
                                  classNames['view-job-others'] +
                                  ' ' +
                                  classNames['view-job-close']
                                }
                              >
                                <Trans
                                  i18nKey={'Search_Job_ClosesStatus'}
                                  t={t}
                                  defaults={
                                    'Closes in {{position_closing_num}} {{position_closing_unit}}'
                                  }
                                  components={{
                                    1: <strong />,
                                  }}
                                  values={{
                                    position_closing_num:
                                      j?.hr_closing_days_left,
                                    position_closing_unit:
                                      j?.hr_closing_days_left
                                        ? t('JOB_BOARD_LIST_days')
                                        : '',
                                  }}
                                />{' '}
                              </div>
                            </div>
                            <div className={classNames['apply-and-view-btn']}>
                              {(j?.experience_from && j?.experience_to) ||
                              j?.experience_to ? (
                                <>
                                  <div
                                    className={
                                      'd-flex' +
                                      ' ' +
                                      classNames['experience-text-color']
                                    }
                                  >
                                    <span>
                                      <img
                                        className={
                                          classNames['view-job-ex-sub']
                                        }
                                        src={PathIcon}
                                      ></img>
                                    </span>
                                    {`${j?.experience_from || 0} - ${
                                      j?.experience_to
                                    }`}{' '}
                                    {t('Search_Job_Years Experience')}
                                  </div>
                                </>
                              ) : (
                                <div
                                  className={
                                    'd-flex' +
                                    ' ' +
                                    classNames['experience-text-color']
                                  }
                                >
                                  <span>
                                    <img
                                      className={classNames['view-job-ex-sub']}
                                      src={PathIcon}
                                    ></img>
                                  </span>
                                  {t('JOB_BOARD_Fresher')}
                                </div>
                              )}
                              <div className={classNames['apply-submit-btn-m']}>
                                <button
                                  className={`mr-2 ${classNames['apply-btn']}`}
                                  onClick={() => handleRedirectView(j, 'apply')}
                                >
                                  {t('Apply')}
                                </button>
                                <button
                                  className={classNames['view-btn']}
                                  onClick={() => handleRedirectView(j, 'view')}
                                >
                                  {t('Search_Job_View Job')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className={classNames['pagination']}>
                  {isFetchingNextPage ? <Loading /> : <></>}
                  <Pagination
                    loadNext={isFetchingNextPage}
                    displayCount={jobboardList?.length}
                    totalCount={totalJobListCount}
                  />
                </div>
              </div>
            </>
          ) : !isLoading && !jobboardList?.length ? (
            <div className={classNames['records-not-found']}>
              {t('Records Not Found')}
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <div className={classNames['menu-item-mv']}>
        <JobBoardMenuMobileView active={'search-job'} />
      </div>
    </>
  );
};

export default InternalJobBoardList;
